
//Default State
var isSupported = false;
var isGGRunning = false;
// get url params
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const route = document.querySelector('.deepLink-wrapper').getAttribute('data-url');
const clientArguments = "ssgg://" + route + queryString;
var appTitle = capitalizeFirstLetter(route.substring(route.indexOf('/') + 1));
if (route.indexOf('/') !== route.lastIndexOf('/') && route.indexOf('sonar') >= -1)
  appTitle = 'SONAR';
document.body.innerHTML = document.body.innerHTML.replace('%App_Name%', appTitle);


//Random background
document.addEventListener("DOMContentLoaded", function () {
  var bgArray = [
    'ss_wallpaper_01.png',
    'ss_wallpaper_02.png',
    'ss_wallpaper_03.png',
    'ss_wallpaper_04.png',
    'ss_wallpaper_05.png',
    'ss_wallpaper_06.png',
    'ss_wallpaper_07.png',
    'ss_wallpaper_08.png',
    'ss_wallpaper_09.png',
    'ss_wallpaper_10.png'];
  var bg = bgArray[Math.floor(Math.random() * bgArray.length)];
  var path = '/static/img/deeplink/';
  var imageUrl = path + bg;
  document.querySelector('.deepLink-wrapper').style.backgroundImage = 'url(' + imageUrl + ')';
});


window.onload = () => {
  if (isPhoneOrTablet()) {
    launchMobile();
  }
  else {
    recursiveConnect();
  }
};


async function recursiveConnect() {
  var promArr = [];
  for (var i = 6327; i <= 6336; i++) {
    try {
      const prom = createWebSocket(`${i}`, "/externalSock", promArr);
    }
    catch (error) {
      // console.log(error);
    }
  }
}

// ################## SUPPORTING FUNCTIONS #######################

function capitalizeFirstLetter(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

function openGGbecauseIsNotRunning() {
  if (navigator.userAgent.includes("Firefox/")) {
    launchChrome();
  } else if (navigator.userAgent.includes("MSIE")) {
    launchIE();
  } else if (navigator.userAgent.match(/Edg\//)) {
    launchChrome();
  } else if (navigator.userAgent.match(/Opera|OPR\//)) {
    launchOpera();
  } else if (navigator.userAgent.includes("Chrome/")) {
    launchChrome();
  } else
    launchChrome();
}

function createWebSocket(port: string, channel: string, promArr: Array<string>) {
  const endpoint = 'ws://127.0.0.1:' + port + channel;
  console.log(clientArguments);
  const webSocket = new WebSocket(endpoint); // In the constructor we use the loopback address and a free port
  var apiCall = {
    "event": "EVENT_START_CLIENT",
    "data": {
      "clientArguments": [
        clientArguments
      ]
    }
  };
  webSocket.onopen = () => {
    console.log('open and sending call');
  };
  webSocket.onmessage = (message) => {
    const event = JSON.parse(message.data);
    if (event.event === 'EVENT_NEW_CLIENT_CONNECTED') {
      const loadingElem = document.querySelector(".deepLink-card-loading");
      loadingElem.style.display = "none";
      const afterOpenElem = document.querySelector(".deepLink-card-success");
      afterOpenElem.style.display = "flex";
      promArr.push('connected');
      webSocket.send(JSON.stringify(apiCall));
      webSocket.close();
    }
  };
  webSocket.onerror = (err) => {
    promArr.push(null);
    if (!promArr.includes('connected') && promArr.length == 10) {
      //No socket open means GG is closed. Case 2
      console.log('Open GG with custom protocol');
      openGGbecauseIsNotRunning();
    }
  };
  webSocket.onclose = function (event) {
    console.log(event.code);
  };
}

function result() {
  if (isSupported) {
    const loadingElem = document.querySelector(".deepLink-card-loading");
    loadingElem.style.display = "none";
    const afterOpenElem = document.querySelector(".deepLink-card-success");
    afterOpenElem.style.display = "flex";
  }
  else {
    //Redirect to download
    const loadingElem = document.querySelector(".deepLink-card-loading");
    loadingElem.style.display = "none";
    const afterOpenElem = document.querySelector(".deepLink-card-toDownload");
    afterOpenElem.style.display = "flex";
    window.setTimeout(function () {
      let finalRoute = 'gg';
      if (route.indexOf('engine') >= 0)
        finalRoute = 'engine';
      if (route.indexOf('moments') >= 0)
        finalRoute = 'moments';
      else if (route.indexOf('giveaways') >= 0 || route.indexOf('home') >= 0)
        finalRoute = 'gg';
      window.location = window.origin + '/' + finalRoute;
    }, 2000);
  }
}

function resultMobile() {
  //Redirect to download
  const loadingElem = document.querySelector(".deepLink-card-loading");
  loadingElem.style.display = "none";
  const afterOpenElem = document.querySelector(".deepLink-card-noMobile");
  afterOpenElem.innerHTML = afterOpenElem.innerHTML.replaceAll('%App_Name%', capitalizeFirstLetter(route.substring(route.indexOf('/') + 1)));
  afterOpenElem.style.display = "flex";
  window.setTimeout(function () {
    let finalRoute = 'gg';
    if (route.indexOf('engine') >= 0)
      finalRoute = 'engine';
    if (route.indexOf('moments') >= 0)
      finalRoute = 'moments';
    else if (route.indexOf('giveaways') >= 0 || route.indexOf('home') >= 0)
      finalRoute = 'gg';
    window.location = window.origin + '/' + finalRoute;
  }, 2000);
}

function isIOS() {
  var ua = window.navigator.userAgent;
  var iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
  var webkit = !!ua.match(/WebKit/i);
  return iOS && webkit && !ua.match(/CriOS/i);
}

function isPhoneOrTablet() {
  let check = false;
  (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
}

//Handle IE
function launchIE() {
  var aLink = document.querySelector('#hiddenLink');

  isSupported = false;
  aLink.href = url;

  //Case 1: protcolLong
  console.log("Case 1");
  console.log(aLink.protocolLong);
  if (navigator.appName == "Microsoft Internet Explorer" &&
    aLink.protocolLong == "Unknown Protocol") {
    isSupported = false;
    result();
    return;
  }

  //Case2: Open New Window, set iframe src, and access the location.href
  console.log("Case 2");
  var myWindow = window.open('', '', 'width=0,height=0');
  myWindow.document.write("<iframe src='" + clientArguments + "></iframe>");
  setTimeout(function () {
    try {
      myWindow.location.href;
      isSupported = true;
    } catch (e) {
      //Handle Exception
      console.log(e);
    }

    if (isSupported) {
      myWindow.setTimeout('window.close()', 100);
    } else {
      myWindow.close();
    }
    result();
  }, 2000);
}

function launchEdge() {

}

function launchOpera() {
  var iFrame = document.querySelector('#hiddenIframe');
  isSupported = false;

  iFrame.contentWindow.location = clientArguments;
  window.setTimeout(function () {
    try {
      // alert('clientArguments');
      isSupported = true;
      result();
    } catch (e) {
      isSupported = false;
      result();
    }
  }, 0);
}

//Handle Firefox
function launchMozilla() {
  var iFrame = document.querySelector('#hiddenIframe');

  isSupported = false;

  //Set iframe.src and handle exception
  try {
    iFrame.contentWindow.location.href = clientArguments;
    isSupported = true;
    result();
  } catch (e) {
    //Firefox
    if (e.name == "NS_ERROR_UNKNOWN_PROTOCOL") {
      isSupported = false;
      result();
    }
  }
}

//Handle Chrome
function launchChrome() {
  var protcolEl = document.querySelector('.deepLink-wrapper');

  isSupported = false;

  protcolEl.focus();
  protcolEl.onblur = function () {
    isSupported = true;
    console.log("Text Field onblur called");
    console.log("Installed and running");
  };

  //will trigger onblur
  location.href = clientArguments;

  setTimeout(function () {
    protcolEl.onblur = null;
    // Cancelled or not installed
    result();
  }, 2000);
}

//Handle Mobile
function launchMobile() {
  isSupported = false;
  // Cancelled or not installed
  resultMobile();
}